import type { DocMigration } from "../docMigration";

const facadeDependencyEntityTypes = ["FACADE_SPAN_STRATUM", "FACADE_SWEEP_STRATUM"] as const;

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_461: DocMigration = {
  maxSchemaVersion: "0.0.461",
  description: "Delete facadeSpanStratum and facadeSweepStratum orphaned entity refs.",
  apply(json: any): any {
    if (!Object.keys(json.entityRefs).length) {
      return json;
    }

    for (const id in json.entityRefs) {
      const entityRef = json.entityRefs[id];

      if (!entityRef.entityType) {
        continue;
      }

      if (!facadeDependencyEntityTypes.includes(entityRef.entityType)) {
        continue;
      }

      if (entityRef.entityType === "FACADE_SPAN_STRATUM") {
        const facadeSpanStratum = json.facadeSpanStrata[entityRef.id];

        // If the facade span stratum is not present, delete the entity ref
        if (!facadeSpanStratum || !facadeSpanStratum.parentId) {
          delete json.entityRefs[id];
          continue;
        }

        const facade = json.facades[facadeSpanStratum.parentId];

        if (!facade) {
          delete json.entityRefs[id];
          continue;
        }

        // If the facade itself is not doc ref'd, delete the entity ref for the facade span stratum
        if (!json.entityRefs[facade.id]) {
          delete json.entityRefs[id];
          continue;
        }
      }

      if (entityRef.entityType === "FACADE_SWEEP_STRATUM") {
        const facadeSweepStratum = json.facadeSweepStrata[entityRef.id];

        // If the facade sweep stratum is not present, delete the entity ref
        if (!facadeSweepStratum || !facadeSweepStratum.parentId) {
          delete json.entityRefs[id];
          continue;
        }

        const facade = json.facades[facadeSweepStratum.parentId];

        if (!facade) {
          delete json.entityRefs[id];
          continue;
        }

        // If the facade itself is not doc ref'd, delete the entity ref for the facade sweep stratum
        if (!json.entityRefs[facade.id]) {
          delete json.entityRefs[id];
          continue;
        }
      }
    }
    return json;
  },
};

export default migration_0_0_461;
